export default "__VITE_ASSET__0bd24952__"